<script setup>
  const props = defineProps({
    breadcrumbs: { type: Array, required: false, default: [] },
    parent: { type: Object, required: false },
    category: { type: Object, required: false },
    sections: Array,
    categories: Array,
    module: Object,
    posts: Object,
  });
</script>
<template>
  <main>
    <div class="container">
      <SfBreadcrumbs :breadcrumbs="breadcrumbs" />
      <SectionRenderer :sections="sections" placement="before" />
      <div class="blog-wrapper">
        <div class="articles-wrapper">
          <SegmentHeading class="blog-title" large type="h1" :class="{'category': category?.title}">
            {{ category?.title || module.title }}
          </SegmentHeading>
          <div v-if="category?.description_short || module.description_short"
            class="description" v-html="category?.description_short || module.description_short" />
          <Articles v-if="posts.data.length > 0" :posts="posts.data" />
          <SfDataPlaceholder v-else>
            {{ $t('Brak wpisów do wyświetlenia.') }}
          </SfDataPlaceholder>
          <SfPagination :pagination="posts" />
        </div>
        <FiltersBlog :categories="categories" :category="category" :parent="parent" class="filters" />
      </div>
    </div>
    <SectionRenderer :sections="sections" placement="after" />
  </main>
</template>
<style lang="scss" scoped>

  .description {
    margin-bottom: 2rem;
  }

  .blog-wrapper {
    display: grid;
    grid-template-columns: 3fr minmax(320px, 1fr);
    align-items: flex-start;
    width: 100%;
    gap: 2rem;
    margin: 2rem 0 6.25rem 0;
  }

  .articles-wrapper {
    gap: 1.25rem;

    .blog-title {
      margin-bottom: 3rem;

      &.category::after {
        display: none;
      }
    }
  }

  .filters {
    position: sticky;
    top: 170px;
    padding: 1.5rem;
    background-color: var(--color-light-gray);
  }

  @media (max-width: 992px) {
    .blog-wrapper {
      grid-template-columns: 1fr;
      margin: 2rem 0;
    }

    .description {
      padding: 0 1rem;
      font-size: 0.875rem;
    }

    .articles-wrapper .blog-title {
      margin: 0 1rem 2.25rem;
    }
  }
</style>
